module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/footer/desktop_BG-1b88e80aea8f530bd6905bbd90cc4a7d.svg";